export default {
    listagem: {
        titulo_pagina: 'Resultados Editables',
        table: {
            empty: 'No se encontraron Vns',
            nome: 'Vns',
            empresa: 'Empresa',
            resultado_editavel: 'Resultado Editable',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            editar: 'Editar Resultados Editables'
        },
        fields: {
            vns: {
                label: 'Vns',
                description: 'Nombre del Vns'
            },
            report_editable: {
                label: 'Resultados Editables',
                description: 'Resultados que serán editados por vns'
            },
            exam: {
                label: 'Examen'
            },
            mnemonic: {
                label: 'Mnemónico'
            },
            action: {
                label: 'Acción'
            }
        },
        buttons: {
            adicionar_exame: 'Agregar Examen',
            remover_exame: 'Eliminar Examen',
            botao_salvar: 'Guardar Resultados Editables'
        },
        update: {
            success: '¡Resultados editables actualizados con éxito!',
            error: '¡Error al actualizar los resultados editables!'
        }
    }
}